import {GA_FAILURE, GA_PENDING, GA_SUCCESS, GNI_SUCCESS, GNI_PENDING, DI_SUCCESS} from './constants'

const initialState = {
  selected: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GA_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case GA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        selected: action.payload,
      }
    case GNI_PENDING:
      var entity_objects_loading = [
        ...state.selected.expand_details.entities_attributes[0].entity_objects,
        {id: 'loading', display_field: ''},
      ]
      state.selected.expand_details.entities_attributes[0].entity_objects = entity_objects_loading
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    case DI_SUCCESS:
      const indexOfDeleteItem = state.selected.expand_details.entities_attributes[0].entity_objects.findIndex(
        a => {
          return a.id === 'loading'
        }
      )
      state.selected.expand_details.entities_attributes[0].entity_objects.splice(
        indexOfDeleteItem,
        1
      )
      return {
        ...state,
      }
    case GNI_SUCCESS:
      var entity_objects = [
        ...state.selected.expand_details.entities_attributes[0].entity_objects,
        ...action.payload.entity_objects,
      ]
      state.selected.expand_details.entities_attributes[0].entity_objects = entity_objects
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    case GA_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
